import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchBusTypes = createAsyncThunk('busTypes/fetch', async (params, { rejectWithValue }) => {
  try { const res = await service.getBusTypes(params); return { params, data: res.data, meta: res.meta } } catch (e) { return rejectWithValue(e.response?.data || e.message) }
})
export const fetchBusType = createAsyncThunk('busTypes/fetchOne', async (id, { rejectWithValue }) => { try { return await service.getBusType(id) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const addBusType = createAsyncThunk('busTypes/add', async (payload, { rejectWithValue }) => { try { return await service.addBusType(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const saveBusType = createAsyncThunk('busTypes/save', async (payload, { rejectWithValue }) => { try { return await service.updateBusType(payload) } catch (e) { return rejectWithValue(e.response?.data || e.message) } })
export const removeBusType = createAsyncThunk('busTypes/remove', async (id, { rejectWithValue }) => { try { await service.deleteBusType(id); return id } catch (e) { return rejectWithValue(e.response?.data || e.message) } })

const slice = createSlice({
  name: 'busTypes',
  initialState: { data: [], meta: null, params: { page: 1, take: 10, order: 'ASC', q: '' }, selected: null, loading: false, error: null },
  reducers: { setBusTypeParams(s, a) { s.params = a.payload } },
  extraReducers: b => {
    b.addCase(fetchBusTypes.pending, s => { s.loading = true })
     .addCase(fetchBusTypes.fulfilled, (s, a) => { s.loading = false; s.data = a.payload.data; s.meta = a.payload.meta; s.params = a.payload.params })
     .addCase(fetchBusTypes.rejected, (s, a) => { s.loading = false; s.error = a.payload })
     .addCase(fetchBusType.fulfilled, (s, a) => { s.selected = a.payload })
     .addCase(addBusType.fulfilled, (s, a) => { s.data.unshift(a.payload) })
     .addCase(saveBusType.fulfilled, (s, a) => { const i = s.data.findIndex(x => x.id === a.payload.id); if (i > -1) s.data[i] = a.payload })
     .addCase(removeBusType.fulfilled, (s, a) => { s.data = s.data.filter(x => x.id !== a.payload) })
  }
})

export const { setBusTypeParams } = slice.actions
export default slice.reducer
